import {
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from "react-native";
import { Colors, Typography } from "../../../styles";
import { FontAwesome5 } from "@expo/vector-icons";
import { Data } from "../../../types";
import { entityIcon } from "../../../utils/data";

const Entity = ({
  entity,
  size,
  isOpaque,
  onPress,
  style,
}: {
  entity: Data.Entity;
  size: "small" | "large";
  isOpaque: boolean;
  onPress?: () => void;
  style?: ViewStyle;
}) => {
  const iconSize = size === "small" ? 18 : 20;
  const fontSize = size === "small" ? 14 : 20;
  const color = isOpaque ? Colors.white : Colors.plum400;

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <View style={[styles.container, style]}>
        <FontAwesome5
          name={entityIcon(entity)}
          size={iconSize}
          color={color}
          style={styles.sourceIcon}
        />
        <Text
          style={[
            Typography.title,
            {
              fontSize,
              color,
              fontFamily: Typography.weightRegular.fontFamily,
            },
          ]}
        >
          {entity.charAt(0).toUpperCase() + entity.slice(1)}
        </Text>
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  sourceIcon: {
    marginRight: 6,
    marginTop: 4,
  },
});

export default Entity;
